import { put, takeEvery } from 'redux-saga/effects';

import { tagsActions } from 'app-components/flux/tags';
import { transactionsActions as actions } from 'app-components/flux/transactions';

export function* deleteTagActionWatcher() {
  yield takeEvery(tagsActions.deleteTag, function* deleteTag(action) {
    if (action?.meta?.txns?.size) {
      yield put(actions.batchTransactions(action.meta.txns));
    }
  });
}

export default [deleteTagActionWatcher];
